"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRecordOrientationMatchesDto = instanceOfRecordOrientationMatchesDto;
exports.RecordOrientationMatchesDtoFromJSON = RecordOrientationMatchesDtoFromJSON;
exports.RecordOrientationMatchesDtoFromJSONTyped = RecordOrientationMatchesDtoFromJSONTyped;
exports.RecordOrientationMatchesDtoToJSON = RecordOrientationMatchesDtoToJSON;
exports.RecordOrientationMatchesDtoToJSONTyped = RecordOrientationMatchesDtoToJSONTyped;
/**
 * Check if a given object implements the RecordOrientationMatchesDto interface.
 */
function instanceOfRecordOrientationMatchesDto(value) {
    if (!('orientationId' in value) || value['orientationId'] === undefined)
        return false;
    if (!('nurseProfileIds' in value) || value['nurseProfileIds'] === undefined)
        return false;
    return true;
}
function RecordOrientationMatchesDtoFromJSON(json) {
    return RecordOrientationMatchesDtoFromJSONTyped(json, false);
}
function RecordOrientationMatchesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orientationId': json['orientationId'],
        'nurseProfileIds': json['nurseProfileIds'],
    };
}
function RecordOrientationMatchesDtoToJSON(json) {
    return RecordOrientationMatchesDtoToJSONTyped(json, false);
}
function RecordOrientationMatchesDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orientationId': value['orientationId'],
        'nurseProfileIds': value['nurseProfileIds'],
    };
}
//# sourceMappingURL=RecordOrientationMatchesDto.js.map